export default __webpack_public_path__ + "static/media/WINE.3143bb3d.png";